export enum AiDefaultValueType {
    TEXT = "TEXT",
    TEXTAREA = "TEXTAREA",
    JSON = "JSON",
    ENUM = "ENUM",
    AI_PROMPT = "AI_PROMPT",
    AI_REPORT_SUMMARIZER = "AI_REPORT_SUMMARIZER",
    ITEM_UPDATE_PROFILE = "ITEM_UPDATE_PROFILE"
}

export class AiDefaultOption {
    constructor(
        public value?: string,
        public label?: string
    ) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        return new AiDefaultOption(data.value, data.label);
    }
}

export class AiDefaultEntry {
    constructor(
        public key?: string,
        public section?: string,
        public label?: string,
        public description?: string,
        public value?: string,
        public defaultValue?: string,
        public nullable?: boolean,
        public valueType?: AiDefaultValueType,
        public options?: AiDefaultOption[]
    ) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const options = data.options ?? [];

        return new AiDefaultEntry(
            data.key,
            data.section,
            data.label,
            data.description,
            data.value,
            data.defaultValue,
            data.nullable,
            data.valueType,
            options.map((option: any) => AiDefaultOption.fromPOJO(option))
        );
    }
}

class AiDefaults {
    constructor(
        public entries?: AiDefaultEntry[]
    ) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entries = data.entries ?? [];

        return new AiDefaults(entries.map((entry: any) => AiDefaultEntry.fromPOJO(entry)));
    }
}

export default AiDefaults;
